export default __webpack_public_path__ + "9c1117cb8cae54c99d5f537b6e802953.png";